<template>
    <section v-show="isActive" class="tabs-component-panel">
        <slot />
    </section>
</template>

<script>
    export default {
        props: {
            label: { required: true },
            prefix: { default: '' },
            suffix: { default: '' },
        },
        data: () => ({
            isActive: false,
        }),
        computed: {
            header() {
                return this.prefix + this.label + this.suffix;
            },
        },
    };
</script>

<style lang="scss">
	@import '../styling/global_vars';
</style>



// WEBPACK FOOTER //
// Tab.vue?209e4396